import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Beto_Title } from '../../../../../utils/EN/Modals/VideoModals';

const ModalVideoBeto = () => {
  return (
    <>
      <ModalVideo
        id="beto-videoclips"
        dataText={Beto_Title}
        videoSrc="https://player.vimeo.com/video/297990579?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_BETO"
      />
    </>
  );
};

export default ModalVideoBeto;
